<template>
  <div class="b-textarea">
    <label class="b-textarea__label">
      <template v-if="label">
        {{ label }}
        <span v-if="required" class="b-textarea__required">*</span>
      </template>
      <textarea
        :class="['b-textarea__input', { 'b-textarea__input--error': error }]"
        v-model="vModel"
        :name="name"
        :rows="rows"
        :placeholder="placeholder"
        :disabled="disabled"
      ></textarea>
    </label>
    <p class="b-textarea__error" v-if="error">{{ error }}</p>
    <p class="b-textarea__hint" v-else-if="hint">{{ hint }}</p>
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    value: { type: String },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean },
    label: { type: String },
    placeholder: { type: String },
    name: { type: String },
    rows: { type: Number, default: 5 },
    error: { type: String, default: '' },
    hint: { type: String, default: '' },
  },
  computed: {
    vModel: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.b-textarea
  position: relative

  &__label
    font-size: 14px
    line-height: 1.3
    color: #1E253B

  &__required
    font-size: 13px

  &__input
    display: block
    width: 100%
    padding: 11px 24px
    margin-top: 8px
    border-radius: 3px
    color: $dark-shades-black
    font-size: 14px
    line-height: 1.4
    resize: none
    border: 1px solid #e7e7e8
    transition: border-color .2s

    &--error
      border-color: $error

    &:focus
      border-color: #00c8d7

    &::placeholder
      font-size: 14px
      line-height: normal
      color: $gray-text

  &__error, &__hint
    position: absolute
    bottom: -15px
    font-size: 12px
    line-height: 1

  &__required, &__error
    color: $error
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/lk/form/BaseTextarea.vue